export default "__VITE_ASSET__08221309__"